import { Component, Input, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BaseAvatarSize, BaseTabInterface, CustomerBranchListItemResponse } from 'base';
import { BaseCustomerProviderModalTabs } from '../../../offers/_const/base-customer-provider-modal-tabs.const';
import { BaseCustomerProviderTabsEnum } from '../../../inquiry/_enums/base-customer-provider-tabs.enum';

@Component({
  selector: 'base-customer-provider-details-modal',
  templateUrl: './provider-details-modal.component.html',
})
export class ProviderDetailsModalComponent implements OnInit {
  @Input({ required: true }) provider: CustomerBranchListItemResponse;
  @Input({ required: true }) detailsModalRef: NgbModalRef;
  @Input({ required: true }) isIZSTab: boolean = false;

  tabs = [...BaseCustomerProviderModalTabs];
  currentTab = this.tabs[BaseCustomerProviderTabsEnum.MaterData];
  avatarSize = BaseAvatarSize;
  providerTabsEnum = BaseCustomerProviderTabsEnum;

  ngOnInit() {
    this.currentTab = this.isIZSTab ? this.tabs[this.providerTabsEnum.IZS] : this.tabs[this.providerTabsEnum.MaterData];
  }

  closeDetailsModal(): void {
    this.detailsModalRef.close();
  }

  onTabChange(tab: BaseTabInterface): void {
    this.currentTab = tab;
  }
}
